<template>
  <div>
    <v-menu
      v-if="!readonly"
      v-model="menu"
      :nudge-left="40"
      transition="scale-transition"
      offset-y
      min-width="auto"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          ref="datetime"
          v-model="val"
          readonly
          :label="label"
          :prepend-inner-icon="prependIcon"
          :dense="dense"
          v-bind="attrs"
          :disabled="disabled"
          v-on="on"
          :rules="rules"
          @change="change"
          :outlined="outlined"
        ></v-text-field>
      </template>
      <v-card>
        <v-card-text>
          <vc-date-picker
            mode="dateTime"
            v-model="val"
            :model-config="{
              type: 'string',
              mask: 'YYYY-MM-DD HH:mm:ss',
            }"
            :masks="{ inputDateTime: 'YYYY-MM-DD HH:mm:ss' }"
            :min-date="minDate"
            :max-date="maxDate"
            :locale="lang"
            is24hr
          ></vc-date-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="menu = false">取消</v-btn>
          <v-btn color="primary" text @click="confirmSelection">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
    <v-text-field
      v-else
      ref="datetime"
      v-model="val"
      readonly
      :label="label"
      :prepend-inner-icon="prependIcon"
      :dense="dense"
      :disabled="disabled"
      :rules="rules"
      @change="change"
      :outlined="outlined"
    ></v-text-field>
  </div>
</template>
<script>
export default {
  name: 'vs-datetime-picker',
  model: {
    prop: 'value',
    event: 'update',
  },
  inject: {
    form: { default: null },
  },
  data() {
    return {
      menu: false,
      val: null,
    }
  },

  watch: {
    value(val) {
      this.val = val
    },
    val(val) {
      this.$emit('update', val)
    },
  },

  props: {
    value: String,
    outlined: [Boolean, String],
    useNow: [Boolean, String],
    rules: Array,
    label: String,
    disabled: [Boolean, String],
    readonly: [Boolean, String],
    dense: [Boolean, String],
    prependIcon: {
      type: String,
      default: 'mdi-calendar-clock',
    },
    minDate: String,
    maxDate: String,
  },

  methods: {
    change() {
      this.$emit('update', this.val)
    },
    confirmSelection() {
      this.menu = false
      this.$emit('update', this.val)
    },
    validate(force, value) {
      return this.$refs.datetime.validate(force, value)
    },
    reset() {
      this.$refs.datetime.reset()
    },
    resetValidation() {
      this.$refs.datetime.resetValidation()
    },
    formatDateTime(dateTime) {
      if (!dateTime) return ''
      const date = new Date(dateTime)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
  },

  created() {
    this.form && this.form.register(this)
    if (this.useNow) {
      this.val = this.formatDateTime(new Date())
    } else {
      this.val = this.value
    }
  },
  computed: {
    lang() {
      const values = String(document.cookie || '')
        .split(';')
        .map((c) => c.trim())
        .filter((c) => c.startsWith('language='))
        .map((c) => c.substring('language='.length))
      const lang = values.length ? values[values.length - 1] : 'zh'
      return lang === 'en' ? 'en' : 'zh'
    },
  },

  beforeDestroy() {
    this.form && this.form.unregister(this)
  },
}
</script>

<style></style>
